import { auth } from 'common/api/auth';

// import setCurrentValues from '../../profile/actions/setCurrentValues';
import {
    LOGIN_USER,
    LOGIN_USER_FAILURE,
    LOGIN_USER_SUCCESS,
} from '../actionTypes';
import { loginActions } from '../reducer';

export default (data, callback) => (dispatch) => {
    const newValues = {
        auth_token: data.validationToken,
        code: data.code,
    };

    dispatch(loginActions[LOGIN_USER]());

    auth(newValues)
        .then((response) => {
            const { groups, token, ...rest } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('session', JSON.stringify(rest));
            localStorage.setItem('groups', JSON.stringify(groups));
            dispatch(loginActions[LOGIN_USER_SUCCESS]());
            // dispatch(setCurrentValues(response.data));
            if (callback) callback();
        })
        .catch((error) =>
            dispatch(
                loginActions[LOGIN_USER_FAILURE](error?.response?.data?.errors),
            ),
        );
};
